export default __webpack_public_path__ + "static/media/qkss-logo.f1457e3c.png";